import { Stack } from "@mui/material"
import { AccountModel, AccountsFactory, amIImpersonating, Button, Dialog, DialogHandler, fetchRoute, GenericWrapperContext, isValidString, TemplatesFactory, TextField } from "@cakemail-org/ui-components-v2"
import { TButtonRef } from "@cakemail-org/ui-components-v2/dist/esm/components/button/types"
import { t } from "i18next"
import { MouseEvent, useContext, useLayoutEffect, useState } from "react"
import { getBaseBeeTemplate } from "../../../data/bee"
import { ERoutes } from "../../../utils/url"


function CreateAccountDialogContent({ resolve, reject }: { resolve: (value: unknown) => void, reject: (reason?: any) => void }) {
    const { account } = useContext(GenericWrapperContext)
    const [name, setName] = useState("")

    useLayoutEffect(() => {
        const input = document.querySelector(".createAccountInput input") as HTMLInputElement
        input?.focus()
    }, [])

    function handleAreaChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const value = e.currentTarget.value
        setName(value)
    }

    function createAccount(event?: MouseEvent<HTMLButtonElement>, btnRef?: TButtonRef) {
        btnRef?.animate()
        AccountsFactory.create({
            account: { name, trial: false },
            partnerId: amIImpersonating(true) || String(account.id)
        }).then((data) => {
            btnRef?.reset()
            DialogHandler.hide()
            resolve(data)
        }).catch((error) => {
            btnRef?.reset()
            DialogHandler.show({
                isExpress: true,
                type: "error",
                title: t("general-error-action"),
            })
            reject(error)
        })
    }

    return <Stack direction="column" gap={8} marginTop={8}>
        <TextField
            className="createAccountInput"
            label={t("general-name")}
            placeholder={t("general-name-placeholder")}
            value={name}
            onChange={handleAreaChange}
        />

        <Stack direction="row" spacing={2} justifyContent="flex-end" className="dialogBtns">
            <Button
                variant="outlined"
                color="body1"
                size="small"
                onClick={() => {
                    DialogHandler.hide()
                }}
            >
                {t("general-cancel")}
            </Button>
            <Button
                variant="contained"
                color="secondary"
                animated
                onClick={(e, btnRef) => {
                    createAccount(e, btnRef)
                }}
            >
                {t("general-create")}
            </Button>

        </Stack>
    </Stack>
}


export async function showCreateAccountDialog() {
    return new Promise((resolve, reject) => {
        DialogHandler.show({
            managedByContent: true,
            title: t("general-create-account"),
            content: (
                <CreateAccountDialogContent resolve={resolve} reject={reject} />
            ),
        })
    })
}